import { useApolloClient } from '@apollo/client';
import React from 'react';
import { connect } from 'react-redux';
import { Field, SubmissionError, reduxForm } from 'redux-form';

import { notify } from '@/actions/ui';
import Form from '@/components/Form';
import { TextField } from '@/components/FormAdapters';
import { reportProfileSaveFailure } from '@/profile/profileSaveFailure';
import { updateProfile } from '@/profile/store';

const SAVE_ERROR = 'An error occurred when updating your additional information.';

export function AddAdditionalInformationForm({
  userId,
  profileId,
  updateProfile,
  notify,
  onSubmit,
  reset,
  onReset,
  handleSubmit: handleSubmitProp,
  component: Container = Form,
  ...rest
}: any) {
  const client = useApolloClient();
  const handleSubmit = async (values: any) => {
    try {
      await updateProfile({ id: profileId, ...values });
    } catch (err) {
      // SubmissionError, not a raw Error: redux-form resolves with its errors, so
      // neither EditDialog nor DeprecatedSaveForm reads the failure as a success.
      throw new SubmissionError({ _error: reportProfileSaveFailure(err, notify, SAVE_ERROR) });
    }
    // Temporarily until we migrate out of redux, this should be part of the mutation
    client.refetchQueries({ include: ['fetchActivities'] });
    if (onSubmit) {
      onSubmit(values);
    }
  };

  const handleReset = () => {
    reset();

    if (onReset) {
      onReset();
    }
  };

  return (
    <Container {...rest} onSubmit={handleSubmitProp(handleSubmit)} onReset={handleReset}>
      <Field
        multiline
        id="additionalInformation"
        component={TextField}
        name="additional_information"
        fullWidth
        autoFocus
        minRows={3}
        maxRows={15}
        inputProps={{ maxLength: 10000 }}
      />
    </Container>
  );
}

const WrappedAddAdditionalInformationForm = reduxForm({
  form: 'additionalInformation',
  enableReinitialize: true,
})(AddAdditionalInformationForm);

export default connect(
  (state, ownProps) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const profile = state.profiles.fullProfiles[ownProps.profileId];
    return {
      profile,
      initialValues: {
        additional_information: profile.additional_information,
      },
    };
  },
  {
    updateProfile,
    notify,
  }
)(WrappedAddAdditionalInformationForm);
